// Minnesotaänger Mini App — view-transition stub (v1 rewrite).
// New code (not from telegram-tt). View transitions were telegram page
// animation machinery; v1 never starts one, so this module only keeps the
// "no active transition" flag that useVirtualBackdrop still consults.

export function hasActiveViewTransition(): boolean {
  return false;
}
